<script>
import { SwiperSlide } from "swiper/vue";
import { defineAsyncComponent } from "vue";

export default {
  components:{
    'image-carousel': defineAsyncComponent(() => import("@/components/Carousel")),
    'image-gallery': defineAsyncComponent(() => import("@/components/Gallery")),

  },
  setup() {

    return {
      SwiperSlide
    }
  }
}
</script>
